function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  d: "M66.8125 13.1562H16.1875C11.9936 13.1562 8.59375 16.5561 8.59375 20.75V61.25C8.59375 65.4439 11.9936 68.8438 16.1875 68.8438H66.8125C71.0064 68.8438 74.4062 65.4439 74.4062 61.25V20.75C74.4062 16.5561 71.0064 13.1562 66.8125 13.1562Z",
  stroke: "#929292",
  strokeWidth: 5.0625,
  strokeLinejoin: "round"
});
var _ref3 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  d: "M54.2852 33.3418C57.1091 33.3418 59.3984 31.056 59.3984 28.2363C59.3984 25.4167 57.1091 23.1309 54.2852 23.1309C51.4612 23.1309 49.1719 25.4167 49.1719 28.2363C49.1719 31.056 51.4612 33.3418 54.2852 33.3418Z",
  stroke: "#929292",
  strokeWidth: 5.0625,
  strokeMiterlimit: 10
});
var _ref4 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  d: "M49.1719 53.7301L34.6853 39.2928C33.7635 38.3726 32.5245 37.8386 31.2215 37.8001C29.9186 37.7615 28.6501 38.2213 27.6753 39.0854L8.26562 56.3164M36.3887 69.08L56.0972 49.4016C56.9985 48.4999 58.2049 47.9672 59.4795 47.9081C60.754 47.8491 62.0047 48.268 62.9857 49.0825L74.7383 58.8691",
  stroke: "#929292",
  strokeWidth: 5.0625,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
const SvgImage = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 82,
    viewBox: "0 0 83 82",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgImage, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/image.7c6cecbf.svg";
export { ForwardRef as ReactComponent };